import { $getSelection, $isRangeSelection } from "lexical";
import { $isLinkNode, TOGGLE_LINK_COMMAND } from "@lexical/link";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { Link2 } from "lucide-react";

import { useButtonState } from "../useButtonState";

export function LinkButton() {
    const [editor] = useLexicalComposerContext();
    const isActive = useButtonState(() => {
        const selection = $getSelection();
        if (!$isRangeSelection(selection)) return false;
        const node = selection.anchor.getNode();
        return $isLinkNode(node) || $isLinkNode(node.getParent());
    });

    return (
        <button
            type="button"
            className="rte-toolbar-button"
            data-active={isActive}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => {
                if (isActive) {
                    editor.dispatchCommand(TOGGLE_LINK_COMMAND, null);
                    return;
                }
                const url = window.prompt("Enter URL:");
                if (!url) return;
                editor.dispatchCommand(TOGGLE_LINK_COMMAND, url);
            }}
            title="Link"
            aria-label="Link"
        >
            <Link2 size={16} />
        </button>
    );
}
